<template>
  <div class="page-header">
    <div class="container-fluid">
      <h1>
        <slot></slot>
      </h1>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "src/scss/component-helpers";

.page-header {
  background-color: $primary;

  h1 {
    @include roboto(64, 700);
    color: #FFFFFF;
    padding: .78125em 0;
    text-align: center;
    text-transform: uppercase;
  }
}
</style>
